$(document).ready(function() {

	$('img[name=registerCaptchaImg]').attr('src', '/captcha');

});
